(() => {
  const prefillContactForm = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const productName = searchParams.get('produkt')?.trim().slice(0, 200);
    const collectionName = searchParams.get('welt')?.trim().slice(0, 160);
    const productUrl = searchParams.get('produkt_url');

    const productInput = document.querySelector('#contact-product');
    const franchiseInput = document.querySelector('#contact-franchise');
    const productUrlInput = document.querySelector('#contact-product-url');

    if (productName && productInput && !productInput.value) {
      productInput.value = productName;
    }

    if (collectionName && franchiseInput && !franchiseInput.value) {
      franchiseInput.value = collectionName;
    }

    if (productUrl && productUrlInput && !productUrlInput.value) {
      try {
        const parsedProductUrl = new URL(productUrl, window.location.origin);

        const isProductPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(parsedProductUrl.pathname);

        if (parsedProductUrl.origin === window.location.origin && isProductPath) {
          productUrlInput.value = parsedProductUrl.href;
        }
      } catch {
        // Ignore malformed query parameters and leave the form untouched.
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillContactForm, { once: true });
  } else {
    prefillContactForm();
  }
})();
